import React from "react";
import CheckCalendarContainer from '../../organisms/hotel/checkCalendarContainer';
import CheckListPopupContainer from '../../organisms/common/checkListPopupContainer';
import FacilityVacancyCalendarContainer from '../../organisms/hotel/facilityVacancyCalendarContainer';
import { HeaderContainer } from '../../organisms/common/headerContainer';
import { VacancyFooterContainer } from '../../organisms/common/vacancyFooterContainer';
import MembershipPopupContainer from '../../organisms/common/membershipPopupContainer';
import MembershipSearchContainer from '../../organisms/hotel/membershipSearchContainer';
import MembershipVacancyContainer from "../../organisms/hotel/membershipVacancyContainer";
import { Button } from "../../atoms/button";
import { useHistory } from "react-router-dom";
import { useStore } from "react-redux";

class MembershipVacancyTemplate extends React.Component {
  render() {
    return (
      <div>
        <HeaderContainer
            Label categoryLabel1={"空室情報"}
                categoryLabel2={"AVAILABILITY"}
                hideLogo={true}
            // path={"/"}
            // bookedConfirmLabel={"予約確認"}
        />
        <CheckCalendarContainer
            state={this.props.state}
            onClickOpenCalendarWindow={this.props.onClickOpenCalendarWindow}
            checkInFlg={this.props.state.checkInFlg}
            checkOutFlg={this.props.state.checkOutFlg}
            vacancyCheckFlg={this.props.state.vacancyCheckFlg}
            setVacancyInfo={this.props.setVacancyInfo}
        />
        <FacilityVacancyCalendarContainer
            state={this.props.state}
            facilityCalendarFlg={this.props.state.facilityCalendarFlg}
            onClickCalendarMove={this.props.onClickCalendarMove}
            onClickCloseFacilityCalendarWindow={this.props.onClickCloseFacilityCalendarWindow}
            toHotelSearchView={this.props.toHotelSearchView}
        />
        <CheckListPopupContainer
            state={this.props.state}
            onClickOpenCheckListWindow={this.props.onClickOpenCheckListWindow}
        />
        <MembershipPopupContainer
            key={"membershipPopup"}
            state={this.props.state}
            setPopupMode={this.props.setPopupMode}
            setPopupMessage={this.props.setPopupMessage}
            onClickClosePopupWindow={this.props.onClickClosePopupWindow}
            setDisplaySwitchTab={this.props.setDisplaySwitchTab}
            setSelectRecommendFlg={this.props.setSelectRecommendFlg}
            onClickCountWindow={this.props.onClickCountWindow}
        />
        <MembershipVacancyContainer
            state={this.props.state}
            onClickOpenCalendarWindow={this.props.onClickOpenCalendarWindow}
            onClickOpenSavedSearchCriteriaWindow={this.props.onClickOpenSavedSearchCriteriaWindow}
            onClickOpenCheckListWindow={this.props.onClickOpenCheckListWindow}
            onClickOpenFacilityCalendarWindow={this.props.onClickOpenFacilityCalendarWindow}
            setVacancyInfo={this.props.setVacancyInfo}
            toHotelSearchView={this.props.toHotelSearchView}
        />
        <ToReservationSite toHotelSearchView={this.props.toHotelSearchView} />
      </div>
    );
  }
}

const ToReservationSite = (props) => {
    const history = useHistory();
    const store = useStore();
    return (
        <div className="membership_vacancy_foot">
        <Button buttonText="統合予約サイトへ" className={"membership_vacancy_btn"} onClick={ ()=> {props.toHotelSearchView(store, history, null, null);}} />
    </div>
    )
}

export default MembershipVacancyTemplate;